import { render, staticRenderFns } from "./FrontendHeader.vue?vue&type=template&id=6a91d38f&"
import script from "./FrontendHeader.vue?vue&type=script&lang=js&"
export * from "./FrontendHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports